import { FormInstance } from 'antd';
import { useEffect, useState } from 'react';

import { whichPhoneRequired } from '../utils/customerDataFormUtils';

import { formatPhoneNumber } from '~/core/helpers';
import { CustomerDataModel } from '~/core/models';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import {
  selectSelectedCustomerData,
  updateSelectedCustomerData,
} from '~/redux/slices/customerData';

const useCustomerPhone = (form: FormInstance<CustomerDataModel>) => {
  const [isPhoneRequired, setIsPhoneRequired] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const selectedCustomerData = useAppSelector(selectSelectedCustomerData);

  const onChangePhones =
    (phoneType: 'main' | 'alternate') =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const phones =
        phoneType === 'main'
          ? [e.target.value, form.getFieldValue('alternatePhone')]
          : [form.getFieldValue('phone'), e.target.value];

      const [isPhoneRequired] = whichPhoneRequired(...phones);

      setIsPhoneRequired(isPhoneRequired);

      const input = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters

      const phoneProp = phoneType === 'main' ? 'phone' : 'alternatePhone';

      form.setFieldsValue({ [phoneProp]: formatPhoneNumber(input) });
      form.validateFields([phoneProp]);

      dispatch(updateSelectedCustomerData(form.getFieldsValue()));
    };

  useEffect(() => {
    // set the initial required flags for phone numbers based on the new customerData
    const [isPhoneRequired] = whichPhoneRequired(selectedCustomerData?.phone);

    setIsPhoneRequired(isPhoneRequired);
  }, [selectedCustomerData]);
  // Placeholder for any future logic related to customer phone handling

  return { isPhoneRequired, onChangePhones };
};

export default useCustomerPhone;
